import _mixin from '../_mixin'

export default {
  name: 'SVersionReceive',
  cnName: '领取按钮类',
  type: 'activity_version',
  preview: 'https://rescdn-crash.ssjj.cn/website/2023/03/30/dc3e42f445c1787417e8e090fd2b9591.jpeg',
  // 属性相关
  props: {
    activityId: "URIN634ASAZT3JSN7YWWJIMYAA",
    defaultBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/12/763c5a185e9b500c244c7c6933813deb.png',
      style: {
        width: '1920px',
        height: '1017px'
      }
    },
    btnPositionList: [
      { position: 'absolute', top: '90px', left: '256px', width: '165px', height: '50px' },
      { position: 'absolute', top: '90px', left: '566px', width: '165px', height: '50px' },
      { position: 'absolute', top: '90px', left: '877px', width: '165px', height: '50px' }
    ],
    isSignIn: false,
    signInId: "LEONEAB6YTRLYP3FIPFI62RF64",
    isProgress: false,
    progressPositionList: [
      { position: 'absolute', top: '10px', left: '317px', color: '#fff', fontSize: '20px', flag: 1 },
      { position: 'absolute', top: '10px', left: '627px', color: '#fff', fontSize: '20px', flag: 1 },
      { position: 'absolute', top: '10px', left: '937px', color: '#fff', fontSize: '20px', flag: 1 }
    ],
    isCumulativeLogin: false,
    cumulativeLoginPositionList: [
      { top: '10px', left: '317px' }
    ],
    isInviteAward: false
  },
  propsDesc: [
    {
      target: 'activityId',
      label: '活动Id'
    },
    {
      target: 'defaultBg',
      label: '底图',
      formType: 'image'
    },
    {
      target: 'btnPositionList',
      label: '领取类按钮定位',
      formType: 'list',
      listConfig: [
        {
          title: '定位',
          target: 'position'
        },
        {
          title: '上',
          target: 'top'
        },
        {
          title: '左',
          target: 'left'
        },
        {
          title: '按钮宽度',
          target: 'width'
        },
        {
          title: '按钮高度',
          target: 'height'
        }
      ]
    },
    {
      target: 'isProgress',
      label: '是否需要进度',
      formType: 'switch'
    },
    {
      target: 'progressPositionList',
      label: '进度定位',
      formType: 'list',
      listConfig: [
        {
          title: '定位',
          target: 'position'
        },
        {
          title: '上',
          target: 'top'
        },
        {
          title: '左',
          target: 'left'
        },
        {
          title: '字体颜色',
          target: 'color'
        },
        {
          title: '字体大小',
          target: 'fontSize'
        },
        {
          title: '是否显示进度',
          target: 'flag'
        }
      ]
    },
    {
      target: 'isCumulativeLogin',
      label: '是否展示累登天数',
      formType: 'switch'
    },
    {
      target: 'cumulativeLoginPositionList',
      label: '累登天数定位',
      formType: 'list',
      listConfig: [
        {
          title: '上',
          target: 'top'
        },
        {
          title: '左',
          target: 'left'
        }
      ]
    },
    {
      target: 'isInviteAward',
      label: '是否是邀请奖励',
      formType: 'switch'
    },
    {
      target: 'isSignIn',
      label: '是否是签到领取',
      formType: 'switch'
    },
    {
      target: 'signInId',
      label: '签到Id'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
